import React from 'react';
import event from 'event';
import styles from '../../../styles/sessions.scss';
import classNames from 'classnames';

let widthHandler = 8;

class SessionsHandler extends React.Component {
  static defaultProps = {
    type: '',
    value: 0,
    editing: null,
    from: null,
    to: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      startPosition: 0,
      isHover: false,
      isHoverLine: false,
      editing: false,
    };
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseUp = this.onMouseUp.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onLineMouseEnter = this.onLineMouseEnter.bind(this);
    this.onLineMouseLeave = this.onLineMouseLeave.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  addEvent(el, evt, handler) {
    event.addEvent(el, evt, handler);
  }

  removeEvent(el, evt, handler) {
    event.removeEvent(el, evt, handler);
  }

  onMouseDown(e) {
    e.preventDefault();
    this.addEvent(window, 'mousemove', this.onMouseMove);
    this.addEvent(window, 'mouseup', this.onMouseUp);

    let position = e.pageX;

    this.setState({
      editing: true,
      startPosition: position,
      startValue: this.props.from,
    });
    this.props.onEditStart(this.props.index, this.props.type);
  }

  onMouseMove(e) {
    let position = e.pageX;
    let diffPosition = position - this.state.startPosition;
    let diffValue = (diffPosition / this.props.containerWidth) * TIME_DAY;
    let newValue = Math.round(this.state.startValue + diffValue);

    this.props.onChange(this.props.index, this.props.type, newValue);
  }

  onMouseUp() {
    this.removeEvent(window, 'mousemove', this.onMouseMove);
    this.removeEvent(window, 'mouseup', this.onMouseUp);

    this.setState({
      editing: false,
      startPosition: 0,
      startValue: 0,
    });
    this.props.onEditStop();
  }

  onMouseEnter() {
    this.setState({
      isHover: true,
    });
  }

  onMouseLeave() {
    this.setState({
      isHover: false,
    });
  }

  onLineMouseEnter(e) {
    this.setState({
      isHoverLine: true,
      uiDeleteX: e.pageX,
    });
  }

  onLineMouseLeave() {
    this.setState({
      isHoverLine: false,
      uiDeleteX: 0,
    });
  }

  onDelete(e) {
    e.preventDefault();
    this.props.onDelete(this.props.index);
  }

  pad(v) {
    return (v < 10 ? '0' : '') + v;
  }

  secondsToTime(seconds) {
    let hour = parseInt(seconds / 60 / 60, 10);
    let minutes = parseInt((seconds - hour * TIME_HOUR) / 60, 10);
    return this.pad(hour) + ":" + this.pad(minutes);
  }

  render() {
    let line = null;
    let uiDelete = null;

    let left = ((this.props.from - this.props.timeFrom) / TIME_DAY * 100).toFixed(2) + "%";
    let right = ((this.props.to - this.props.timeFrom) / TIME_DAY * 100).toFixed(2) + "%";
    let width = ((this.props.to - this.props.from) / TIME_DAY * 100).toFixed(2) + "%";

    if (this.state.isHoverLine && this.props.editable) {
      let uiDeleteLeft = Math.round(this.state.uiDeleteX - left - this.props.containerLeft);
      if (uiDeleteLeft > widthHandler && uiDeleteLeft < width - widthHandler) {
        uiDelete = <a href="#" style={{left: uiDeleteLeft}} onClick={this.onDelete}>x</a>;
      }
    }

    let clr = this.props.type === "Trades" ? styles["sessions-trades"] : styles["sessions-quotes"];

    line = <div className={classNames(styles["range-line"], clr)} style={{left: left, width: width}}
                onMouseEnter={this.onLineMouseEnter}
                onMouseLeave={this.onLineMouseLeave}>{uiDelete}</div>;

    let labelFrom = <div className={classNames(styles["sessions-label-from"], clr)}
                         style={{left: left}}>{this.secondsToTime(this.props.from - this.props.timeFrom)}</div>;
    let labelTo = <div className={classNames(styles["sessions-label-to"], clr)}
                       style={{left: right}}>{this.secondsToTime(this.props.to - this.props.timeFrom)}</div>;

    return (
      <div>
        {labelFrom}
        {labelTo}
        <div className={classNames(styles["sessions-handler"], styles["sessions-handler-from"], clr)}
             style={{left: left}}
             onMouseDown={this.props.editable ? this.onMouseDown : null}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}
        ></div>
        <div className={classNames(styles["sessions-handler"], styles["sessions-handler-to"], clr)}
             style={{left: right}}
             onMouseDown={this.props.editable ? this.onMouseDown : null}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}
        ></div>
        {line}
      </div>
    );
  }
}

export default SessionsHandler;



// WEBPACK FOOTER //
// ./src/js/Component/Sessions/Handler.jsx